export default __webpack_public_path__ + "static/image_01-e97ab7d66cc0e28ceffb7d407bf878fa.png";